<template>
  <modal height="auto" width="610px" :scrollable="true" adaptive name="copy-code-modal" @before-open="beforeOpen" @before-close="beforeClose">
    <header class="modal__header">
      <template>
        Copy Code
      </template>
      <i class="fas fa-times" @click="$modal.hide('copy-code-modal')"></i>
    </header>
    <main class="modal__body">
      <rum-label>
        Rumie Carousel Preview
      </rum-label>
      <div v-html="computeChannelCode" class="preview__component"></div>
      <rum-label>
        Rumie Carousel Code
      </rum-label>
      <div class="copy__area">
        <div>{{ scriptTag }}</div>
        <div>{{ computeChannelCode }}</div>
      </div>
      <rum-button @click="copyChannelCode">Copy Code</rum-button>
    </main>
  </modal>
</template>

<script>
import unescape from "lodash/unescape";
export default {
  data() {
    return {
      channelName: ""
    };
  },
  computed: {
    projectId() {
      return this.$route.params.id;
    },
    computeChannelCode() {
      return `<rumie-carousel project-id="${this.projectId}" channel-name="${this.channelName}" framing="true" about="true" about-text="Bytes help you learn about" action-title="true" height="350" width="175" transition-time="3000"></rumie-carousel>`
    },
    scriptTag() {
      return unescape(`&lt;script async defer src=&#39;https://bcjs.rumie.org/rumie.js&#39;&gt;&lt;/script&gt;`)
    }
  },
  methods: {
    beforeClose() {
      this.channelName = null;
    },
    beforeOpen(event) {
      const channel = event.params && event.params.channel;
      if (!channel) return;

      this.channelName = channel.name.match(/[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g).map(x => x.toLowerCase()).join('-');
    },
    copyChannelCode() {
      let channelLink = `${this.scriptTag}  ${this.computeChannelCode}`
      this.$copyToClipboard(channelLink);
      this.$notify({
        type: "success",
        title: "Code copied successfully"
      });
    },
  }
};
</script>

<style scoped>
.project-form__row {
  margin-bottom: var(--spacing-4);
}

.copy__area {
  padding: var(--spacing-8) 0;
  background: var(--grey-lighter);
  margin-bottom: var(--spacing-6);
  border-radius: var(--border-8);
  padding-left: var(--spacing-3);
  line-height: 26px;
}
.modal-body__label {
  padding-top: var(--spacing-4);
}

.preview__component {
  margin-bottom: 40px;
}

.modal-body__checkbox {
  padding-top: var(--spacing-2);
}

.modal-body__icon {
  margin-top: var(--spacing-8);
}

.modal-footer__action {
  display: flex;
  justify-content: space-between;
}

.modal-footer__button {
  margin-bottom: var(--spacing-3);
}

.channel-action__delete {
  color: var(--red) !important;
  border-color: var(--red) !important;
}

.channel__action {
  display: flex;
  justify-content: space-between;
  margin-top: var(--spacing-6);
}

.channel__action--add {
  justify-content: flex-end;
}

.modal__body, .modal__footer {
  padding: var(--spacing-8) var(--spacing-6);
}

.modal__footer {
  padding-top: 0;
}
</style>
